export const buildQaLabel = (labels: string[]) =>
  labels.filter(Boolean).join("-");
